import React from "react";
import HeroSlider from "./HeroSlider";
import AdsSlider from "./AdsSlider";
import "../assets/css/HeroSection.css";

const HeroSection = ({ pageType }) => {
  return (
    <section className="hero-section">
      <div className="container-fluid px-0">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-12">
            <HeroSlider pageType={pageType} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;